export default "__VITE_ASSET__BAOyaqnA__"